import { get_token, get_user_details} from "@/router";
import Loader from "@/components/Loader/LoaderView";
import CreatePortal from "@/components/CreatePortal/CreatePortal.vue";
import SubPortalView from "@/components/SubPortal/SubPortalView.vue";
import Swal from 'sweetalert2';


import { client_domain } from "@/main.js";
import { append_active_organization_id } from "@/utils/organization_profile";
import { get_profile_url } from "@/views/home/home_helper.js";

export default {

  components: {
    Loader,
    CreatePortal,
    SubPortalView
  },
  props:{
    portal_admin: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    isHomePage() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },
    visible_your_portals() {
      return Array.isArray(this.your_portals)
        ? this.your_portals.filter(portal =>
            portal.name?.toLowerCase() !== 'default portal' &&
            this.portal_matches_search(portal)
          )
        : [];
    },
    visible_portals() {
      return Array.isArray(this.portals)
        ? this.portals.filter(
            portal =>
              portal.name?.toLowerCase() !== 'default portal' &&
              this.portal_is_discoverable(portal) &&
              this.portal_matches_search(portal)
          )
        : [];
    },
    displayed_your_portals() {
      return this.show_all_your_portals
        ? this.visible_your_portals
        : this.visible_your_portals.slice(0, this.your_portals_visible_count);
    },
    has_more_your_portals() {
      return this.visible_your_portals.length > this.your_portals_visible_count;
    },
    show_your_portals_section() {
      return !this.incident_page && this.user_details.user_role !== 'admin' && this.visible_your_portals.length > 0;
    }
  },
    mounted() {
      this.path_route_name = this.$route.name;
      if(this.$route.name === 'view_incidents'){
        this.incident_page=true
        this.payload={
          filter_values: {
            portal_type__name:'incident'
          }
        }
      }
      else{
        this.payload={}
      }



      if(client_domain.includes('cbo')){
        this.cbo_domain=true

      }

      if(client_domain.includes('chiefluthuli')){
        this.school_domain=true
      }

      if(client_domain.includes('workbook') || client_domain.includes('workstreams') || client_domain.includes('demo') ) {
        this.workbook_domain=true

      }

      this.user_details = get_user_details();
      this.token_exists = get_token();
      this.user_id = this.get_user_id();

      if(this.$route.name!=='home' && this.token_exists){
        this.filterPortals();
      }

    if(this.$route.name === 'view_portal') {
      this.filter_sub_portals();
    }
    },

    data() {
      return ({
        portal_name: '',
        portal_search_query: '',
        cbo_domain: false,
        workbook_domain: false,
        is_visible: true,
        your_portals: [],
        is_public: true,
        portals: [],
        payload:{},
        errors: {},
        isLoading: false,
        loading: true,
        token_exists: false,
        user_details: {
          "user_role": '',
          "user_id": null,
        },
        selectedPortal: null,
        requestedPortals: [],
        requested_users: [],
        path_route_name: '',
        showAll: false,
        visibleCount: 4,
        show_all_your_portals: false,
        your_portals_visible_count: 5,
        request_access:false,
        incident_page:false,
        sub_portals: [],
        isMasterPortal: false,
        school_domain: false
      });
    },
  created(){
    this.fetchPortals();
  },
    watch: {
      '$route.params.portal_id'() {
        this.sub_portals = [];
        this.filter_sub_portals();
        // this.fetchPortals();
      },
      is_public(value) {
        if (value === true || value === 'true') {
          this.is_visible = true;
        }
      }
    },
    methods:{
        getToken() {
            return get_token();
        },
        get_user_id() {
          const user_id = localStorage.getItem('user_id') || '';
          return user_id;
      },
      is_admin_user() {
        return this.user_details.user_role === 'admin' || this.portal_admin;
      },
      portal_is_discoverable(portal) {
        const is_public = String(portal?.is_public).toLowerCase() === 'true';
        const is_visible = String(portal?.is_visible).toLowerCase() === 'true';
        const has_access = portal?.has_access === 'approved';

        return is_public || this.is_admin_user() || has_access || is_visible;
      },
      portal_can_request_access(portal) {
        const is_public = String(portal?.is_public).toLowerCase() === 'true';
        const is_visible = String(portal?.is_visible).toLowerCase() === 'true';

        return (
          !is_public &&
          is_visible &&
          !['approved', 'pending'].includes(portal?.has_access)
        );
      },
      portal_matches_search(portal) {
        const query = String(this.portal_search_query || '').trim().toLowerCase();
        if (!query) return true;

        return [
          portal?.name,
          portal?.description,
          portal?.portal_type?.name,
        ].some((value) => String(value || '').toLowerCase().includes(query));
      },
      toggleShowMore() {
        this.showAll = !this.showAll; // Toggle between showing all and limiting to visibleCount
      },
      toggle_your_portals() {
        this.show_all_your_portals = !this.show_all_your_portals;
      },
        createPortal(){
          if (!this.validatePortalForm()) {
            return;
          }

          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_portal_api/`,
            method: 'POST',
            headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                portal_name: this.portal_name,
                is_public: this.is_public,
                is_visible: String(
                  this.is_public === true || this.is_public === 'true'
                    ? true
                    : this.is_visible
                ),
                ...append_active_organization_id({})
            }),
            success: (data) => {
                if (data.status === "success") {
                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Portal created successfully.',
                    showConfirmButton: false,
                    timer: 1500,
                    position: 'bottom-end',
                    toast: true
                  }).then(() => {
                    window.location.reload();
                    $('#create_portal').modal('hide');
                  })
                }
            },
            error: () => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to create portal.',
                    showConfirmButton: false,
                    timer: 1500,
                    position: 'bottom-end',
                    toast: true
                }).then(() => {
                    window.location.reload();
                    $('#create_portal').modal('hide');
                  })
            }

          })

        },
        validatePortalForm() {
          this.errors = {};
          let isValid = true;
          if (!this.portal_name.trim()) {
            this.errors.portal_name = 'Portal name is required.';
            isValid = false;
          }

          return isValid;
        },
        fetchPortals() {
            this.token_exists = this.getToken();
            $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
            method: 'POST',
            headers: this.token_exists
            ? {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
            }
            : {},
            data: JSON.stringify(append_active_organization_id(this.payload)),
            success: (data) => {
              if (data.portals) {
                this.portals = data.portals.filter(
                  portal => portal.name?.toLowerCase() !== 'default portal'
                );


            } else {
                this.portals = [];
                this.$emit('portals_loaded', this.portals);
            }
            setTimeout(() => {
              this.loading = false;
          }, 1000);
            },
            complete: () => {
                this.isLoading = false;
            }
            });
        },
        handlePortalClick(portal) {
          if (!this.handle_unauthenticated()) {
            return;
          }
          this.selectedPortal = portal;
          $('#all_portals').offcanvas('hide');

          this.is_public = portal.is_public

          if (portal.has_access == "approved") {
            this.$emit('portal_profile', portal);
            this.open_portal(portal.id, portal.name, portal.is_public, portal.portal_type, portal.is_visible);

            $("#portal_request_access").modal('hide');
          }

          else if (portal.has_access == "pending") {
            $("#portal_request_access").modal('hide');
            Swal.fire({
              icon: 'info',
              title: 'Info',
              text: 'Access request already submitted.',
              showConfirmButton: false,
              timer: 3000,
              position: 'bottom-end',
              toast: true
            })
            return;
          }

          else if (!this.portal_can_request_access(portal)) {
            $("#portal_request_access").modal('hide');
            Swal.fire({
              icon: 'info',
              title: 'Invite only',
              text: 'This private portal is only visible to admins and members who were added to it.',
              showConfirmButton: false,
              timer: 3000,
              position: 'bottom-end',
              toast: true
            });
            return;
          }

          else {
            $("#portal_request_access").modal('show');
          }

        },
        getProfileLink(member) {
          // Check if the user is an admin
          if (member.role.role === 'admin' || member.role.role === 'portal_admin') {
            // Return the link for admin profiles
            return `/user_profile?user_id=${member.id}`;
          } else if (member.role.role === 'user') {
            // Return the link for user profiles
            return get_profile_url(member);
          } else {
            // Return a default profile link for other roles
            return `/user_profile?user_id=${member.id}`;
          }
        },

        requestAccess() {
          const rawPortalId = this.selectedPortal?.id || this.selectedPortal?.portal_id || null;
          const PORTAL_ID = rawPortalId ? Number(rawPortalId) : null;

          if (!Number.isInteger(PORTAL_ID)) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Please select a portal before requesting access.',
              showConfirmButton: false,
              timer: 3000,
              position: 'bottom-end',
              toast: true
            });
            $("#portal_request_access").modal('hide');
            return;
          }

          this.request_access = true;
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/request_access_private_portal/`,
            method: 'POST',
            headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                portal_id: PORTAL_ID,
            }),
            success: (data) => {
                if (data.status === "success") {
                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Access request submitted successfully.',
                    showConfirmButton: false,
                    timer: 3600,
                    position: 'bottom-end',
                    toast: true
                  })
                }
                else {
                  Swal.fire({
                    icon: 'info',
                    title: 'Request Already Sent',
                    text: data.message || 'Access request already submitted.',
                    showConfirmButton: false,
                    timer: 3000,
                    position: 'bottom-end',
                    toast: true
                  })
                }
            },
            error: (xhr) => {
              Swal.fire({
                icon: 'error',
                title: 'Access request failed',
                text: xhr.responseJSON?.message || xhr.responseJSON?.portal_id?.[0] || 'Unable to request access for this portal.',
                showConfirmButton: false,
                timer: 3000,
                position: 'bottom-end',
                toast: true
              });
            },
            complete: () => {
                this.isLoading = false;
                this.selectedPortal = null;
                this.request_access = false;
                $("#portal_request_access").modal('hide');
            }
          });
        },
        handle_unauthenticated() {
            if (!this.token_exists) {
                this.$router.push({ name: 'sign_in_finale'});
              return false;
            }
            return true;
        },

        open_portal(portal_id,portal_name,is_public,portal_type,is_visible) {
          if (portal_type?.name === 'incident') {
            this.$router.push({ name: 'view_incidents', 
              state: {
                portal_id: portal_id,
                portal_name: portal_name
              },
              params: { portal: portal_id, portal_name: portal_name,} });
          }
          else if(portal_type?.name === 'publishing'){
             this.$router.push({ name: 'publish_portal', params: { portal_id: portal_id, portal_name: portal_name,} });
          }
           else {
            this.$router.push({ name: 'view_portal', params: { portal_id: portal_id, portal_name: portal_name, is_public: is_public, is_visible: is_visible } });
            this.filterReports(portal_id);
          }
        },

        filterReports(portal_id) {
          this.loading = true;
          const payload = {
            filter_values: {
              portal_id: portal_id
            }
          }
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_reports_api/`,
            method: 'POST',
            headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(payload),
            success: (response) => {
              if(response.status === "success") {
                this.$emit('portal_selected', response.data.report_data);
              }

              setTimeout(() => {
                this.loading = false;
            }, 1000);

            },
            complete: () => {
                this.isLoading = false;
            }
          });
        },

        filterPortals() {
          const user_id = this.user_details.user_id;
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_portals_api/`,
            method: 'GET',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            data: { user_id: user_id },
            success: (response) => {
              if (response.status === "success" && Array.isArray(response.portals)) {
                this.your_portals = response.portals.map(portal => ({
                  ...portal,
                  has_access: "approved"
                }));
              } else {
                this.your_portals = [];
              }

              const discoverable_portals = this.portals.filter(portal =>
                this.portal_is_discoverable(portal)
              );
              const combined = [
                ...discoverable_portals,
                ...this.your_portals.filter(
                  p => !discoverable_portals.some(existing => existing.id === p.id)
                )
              ].filter(p => p.name?.toLowerCase() !== 'default portal');

              this.$emit('portals_loaded', combined);

              setTimeout(() => {
                this.loading = false;
              }, 1000);
            },
            complete: () => {
              this.isLoading = false;
            }
          });
        },

        filter_sub_portals() {
          const master_portal_id = this.$route.params.portal_id;
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_sub_portals_api/`,
            method: 'GET',
            headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
            },
            data:{master_portal_id:master_portal_id},
            success: (response) => {
              if (response.status === "success") {
                const selectedPortal = response.sub_portals.find(
                  portal => portal.id == master_portal_id && portal.name?.toLowerCase() !== 'default portal'
                );

                // Set flag based on is_master
                this.isMasterPortal = selectedPortal?.is_master === true;

                this.sub_portals = response.sub_portals.filter(
                  portal => portal.id != master_portal_id
                );
              }
            },
            complete: () => {
                this.isLoading = false;
            }
          });
        },

      handlefilterPortal(sub_portal) {
        this.$emit('sub_portals', sub_portal);

      },
      getInitials(name) {
        const words = name.trim().split(" ");
        return words.length === 1
          ? words[0].substring(0, 2).toUpperCase()
          : (words[0][0] + words[1][0]).toUpperCase();
      },
    }
}
